import React from 'react';
import './DrawerFooter.less';

export const DrawerFooter = ({leftControl, leftSecondaryControl, rightControl}) => {
	return <ul className="drawer-footer">
		{
			leftControl && (
				<div className="drawer-footer__left-control">
					{leftControl}
				</div>
			)
		}
		{
			leftSecondaryControl && (
				<div className="drawer-footer__left-secondary-control">
					{leftSecondaryControl}
				</div>
			)
		}
		{
			rightControl && (
				<div className="drawer-footer__right-control">
					{rightControl}
				</div>
			)
		}
	</ul>
}
